import { render, staticRenderFns } from "./MachinationsShapesBackground.vue?vue&type=template&id=5a52f9ae&"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports